import React, { useContext, useEffect, useRef, useState } from 'react'
import Button_check from "./Button_check";
import EditItem from "./EditItem"
import Getdata from '../functions/getdata';
import setDataLocal from '../functions/setData';
import deleteItem from '../functions/deleteItem';
import { DataList } from '../context/Datalist';
import { Edit_context } from '../context/Edited-context';
export default function Items({id_el,value,delete_img,complete,inp_todo}) {
    let [Checked,setChecked] = useState(false);
    let Data = useContext(DataList);
    let start_work = useRef(false);
    let {etat,id,setEdited} = useContext(Edit_context); 
    useEffect(_ => {
        if(start_work.current) {
            let result = Getdata().map(ele => {
                if(ele.id === id_el) {
                    ele.complete = Checked;
                }
                return ele;
            });
            setDataLocal(false,result);
            Data.setData(result);
        }   
    },[Checked])

    useEffect(_ => {
        if(complete) {
            setChecked(true);
        }else {
            setChecked(false);
        }
    },[complete])
    return (
    <li>
    <div className={`par ${Checked ? 'complete' : ''}`} onClick={e => {
        if(e.target.classList.contains('btn-check')) {
            start_work.current = true;
        }
    }}>
        <Button_check Checked = {Checked} setChecked = {setChecked}/>
        <span>{value}</span>
    </div>
    <div style={{display:'flex',gap:'10px'}}>
        <img src={delete_img} onClick={_ => Data.setData(deleteItem(id_el))}/>
        <EditItem inp_todo = {inp_todo} value = {value} id_item = {id_el}/>
    </div>

    </li>
  )
}
